export default __webpack_public_path__ + "static/media/pictogramBeaconAccounts128.06e04de3.svg";